export default function ContactSection() {
  return (
    <footer className="w-full" style={{ backgroundColor: 'oklch(var(--foreground-900))' }}>
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="lg:w-1/3">
            <div className="flex items-center gap-3 mb-6">
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center"
                style={{ backgroundColor: 'oklch(var(--primary-500) / 0.2)' }}
              >
                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: 'oklch(var(--primary-400))' }} />
              </div>
              <span
                className="text-sm font-medium tracking-widest uppercase"
                style={{ fontFamily: 'var(--font-label)', color: 'oklch(var(--foreground-300))' }}
              >
                Contact
              </span>
            </div>
            <p
              className="text-2xl md:text-3xl font-heading font-medium leading-tight"
              style={{ color: 'oklch(var(--background-50))' }}
            >
              Let&rsquo;s build
              <br />
              something great
              <br />
              together.
            </p>
          </div>

          <div className="lg:w-2/3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-10">
              <div>
                <h4
                  className="text-xs font-medium tracking-widest uppercase mb-4"
                  style={{ fontFamily: 'var(--font-label)', color: 'oklch(var(--foreground-300))' }}
                >
                  Address
                </h4>
                <address className="not-italic">
                  <p className="text-sm leading-relaxed" style={{ color: 'oklch(var(--foreground-200))' }}>
                    Hutita-Richardi
                  </p>
                  <p className="text-sm leading-relaxed" style={{ color: 'oklch(var(--foreground-200))' }}>
                    Hutita küla
                  </p>
                  <p className="text-sm leading-relaxed" style={{ color: 'oklch(var(--foreground-200))' }}>
                    66627
                  </p>
                  <p className="text-sm leading-relaxed mt-2" style={{ color: 'oklch(var(--foreground-200))' }}>
                    Estonia
                  </p>
                </address>
              </div>

              <div>
                <h4
                  className="text-xs font-medium tracking-widest uppercase mb-4"
                  style={{ fontFamily: 'var(--font-label)', color: 'oklch(var(--foreground-300))' }}
                >
                  Phone
                </h4>
                <p className="text-sm" style={{ color: 'oklch(var(--foreground-200))' }}>
                  +372 57237894
                </p>

                <h4
                  className="text-xs font-medium tracking-widest uppercase mt-8 mb-4"
                  style={{ fontFamily: 'var(--font-label)', color: 'oklch(var(--foreground-300))' }}
                >
                  Email
                </h4>
                <p className="text-sm" style={{ color: 'oklch(var(--foreground-200))' }}>
                  info@apadesolutions.com
                </p>
              </div>
            </div>

            <div
              className="mt-12 pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
              style={{ borderTop: `1px solid oklch(var(--foreground-700) / 0.3)` }}
            >
              <p
                className="text-xs"
                style={{ color: 'oklch(var(--foreground-400))' }}
              >
                Apade Solutions OU &copy; {new Date().getFullYear()}
              </p>
              <p
                className="text-xs"
                style={{ color: 'oklch(var(--foreground-400))' }}
              >
                Professional iOS Engineering &amp; Modern Digital Software Solutions
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}